<template>
  <div
    class="transform left-1/2 -translate-x-1/2 bottom-0 text-center fixed overflow-hidden flex flex-row justify-center z-65000">
    <div class="text-white bg-overlay2 px-8 py-2 text-xs leading-none rounded-tl-lg rounded-tr-lg">
      Created by Miroslav | Version <b>{{ appVersion }}</b> | <span class="hover:underline cursor-pointer"
                                                                    @click="showModal">Privacy Policy</span>
    </div>
    <Teleport to="body">
      <div
        v-if="showLegal"
        class="fixed left-0 top-0 bg-overlay w-full h-full z-65001"
      >
        <div class="bg-white fixed left-1/2 top-1/2 rounded-lg p-8 modal-content text-left">
          <p class="text-center text-xl font-normal">Privacy Policy</p>
          <p class="mt-4">1. This website is maintained by Miroslav with the help of RoC community.</p>
          <p class="mt-2">2. We don't use cookies and we collect no personal information on anybody using this site.</p>
          <p class="mt-2">3. The website is hosted on <a class="hover:underline" href="https://render.com/"
                                                         target="_blank">Onrender.com</a>. Onrender.com's policies and
            conditions apply.</p>
          <p class="mt-4 text-right">
            <button
              class="rounded bg-red-600 hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer"
              @click="closeModal"
            >
              Close
            </button>
          </p>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import {onMounted, ref} from 'vue';

export default {
  setup() {
    const showLegal = ref(false);
    const appVersion = ref('');

    onMounted(() => {
      if (process.env.NODE_ENV === 'production') {
        setTimeout(() => {
          const scripts = document.getElementsByTagName('script');
          for (let i = scripts.length - 1; i >= 0; i--) {
            if (scripts[i].hasAttribute('src')) {
              const src = scripts[i].getAttribute('src');
              if (src.indexOf('/js/app') === 0) {
                appVersion.value = src.replace(/\/js\/app\.([^.]+)\.js/, '$1');
                break;
              }
            }
          }
        }, 500);
      } else {
        appVersion.value = '5697d231';
      }
    });

    return {
      showLegal,
      appVersion,

      showModal() {
        showLegal.value = true;
      },
      closeModal() {
        showLegal.value = false;
      }
    };
  }
};
</script>

<style scoped>
.modal-content {
  width: 600px;
  height: 300px;
  margin-left: -300px;
  margin-top: -150px;
}
</style>
